import API from '../lib/API';
import { CreateServiceCategory,DeleteServiceCategory,ListServiceCategory, UpdateServiceCategory } from './contracts/ServiceCategory.contract';

const route = '/service_category';

export function listServiceCategory(): Promise<ListServiceCategory.Response> {
    return API.get(route);
};

export function createServiceCategory(body: CreateServiceCategory.Body): Promise<CreateServiceCategory.Response> {
    return API.post(route, body);
}

export function updateServiceCategory(id: number, body: UpdateServiceCategory.Body): Promise<UpdateServiceCategory.Response> {
    return API.put(`${route}/${id}`, body);
}

export function deleteServiceCategory(id: number): Promise<DeleteServiceCategory.Response> {
    return API.delete(`${route}/${id}`);
};